<template>
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col" v-if="! isAdmin && ! isPreLoad">
                    <NavButtons :backOnly="true"></NavButtons>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <h2>Conclusion</h2>
                    <p class="paragraph">
                        {{ resultCopy }}
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <h2>How you scored</h2>
                    <div class="legend row">
                        <div class="col"><span class="paragraph--medium guess">What you guessed</span>
                            <span class="paragraph--medium actual">Based on your answers</span></div>
                    </div>
                    <div class="line-graph-wrap d-none d-lg-block">
                        <div class="row slider-bg">
                            <div class="col">
                                <div class="description-block">
                                    <span class="heading">We're starting from scratch <span class="info" id="basics">i</span></span>
                                    <b-popover :target="`basics`" :placement="`top`" triggers="hover focus">
                                        <p>Although aware of electric vehicles and the benefits over their diesel and petrol counterparts,
                                            we are just starting out and unclear about which electric cars or vans would be suitable.</p>
                                    </b-popover>
                                    <div class="slider-spacer"></div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="description-block move-left">
                                    <span class="heading">We have some knowledge <span class="info"  id="getting-by">i</span></span>
                                    <b-popover :target="`getting-by`" :placement="`top`" triggers="hover focus">
                                        <p>We have identified that electric vehicles will be a part of our fleet in the future but have not
                                            yet established timings or identified which electric cars or vans would be suitable.</p>
                                    </b-popover>
                                    <div class="slider-spacer"></div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="description-block move-left">
                                    <span class="heading">We've got the basics covered <span class="info" id="average">i</span></span>
                                    <b-popover :target="`average`" :placement="`top`" triggers="hover focus">
                                        <p>Although we are looking at introducing electric vehicles with a future vision in mind, we are yet
                                            to establish clear plans. However, we have started looking at the best electric car and van
                                            options.</p>
                                    </b-popover>
                                    <div class="slider-spacer"></div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="description-block move-left">
                                    <span class="heading">We're pretty confident <span class="info" id="confident">i</span></span>
                                    <b-popover :target="`confident`" :placement="`top`" triggers="hover focus">
                                        <p>We have identified the full value opportunity of introducing electric vehicles into our fleet and
                                            have identified electric cars or vans suitable for our business, which we will try out
                                            shortly.</p>
                                    </b-popover>
                                    <div class="slider-spacer"></div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="description-block move-right">
                                    <span class="heading">We're EV experts <span class="info" id="expert">i</span></span>
                                    <b-popover :target="`expert`" :placement="`top`" triggers="hover focus">
                                        <p>With clear targets for transition, we are proactively driving the change towards
                                            electric. To find the most suitable electric cars or vans for our driver and business
                                            requirements, we are trying models.</p>
                                    </b-popover>
                                </div>
                            </div>
                        </div>
                        <div class="row line-chart">
                            <div class="col">
                                <LineChart :height="200" :key="refreshChart"></LineChart>
                            </div>
                        </div>
                    </div>
                    <div class="line-graph-wrap d-lg-none">
                        <div class="row slider-bg-grid flex-column-reverse">
                            <div class="col content-block">
                                <div class="description-block">
                                    <span class="heading"> We're starting from scratch <span class="info" tabindex="-1" id="basics-mob">i</span></span>
                                    <b-popover :target="`basics-mob`" :placement="`top`" triggers="focus">
                                        <p>Although aware of electric vehicles and the benefits over their diesel and petrol counterparts,
                                            we are just starting out and unclear about which electric cars or vans would be suitable.</p>
                                    </b-popover>
                                    <div class="slider-spacer"></div>
                                </div>
                                <div class="slider-vertical-spacer"></div>
                            </div>
                            <div class="col content-block">
                                <div class="description-block">
                                    <span class="heading">We have some knowledge <span class="info" tabindex="-1" id="getting-by-mob">i</span></span>
                                    <b-popover :target="`getting-by-mob`" :placement="`top`" triggers="focus">
                                        <p>We have identified that electric vehicles will be a part of our fleet in the future but have not
                                            yet established timings or identified which electric cars or vans would be suitable.</p>
                                    </b-popover>
                                </div>
                                <div class="slider-vertical-spacer"></div>
                            </div>
                            <div class="col content-block">
                                <div class="description-block">
                                    <span class="heading">We've got the basics covered <span class="info" tabindex="-1" id="average-mob">i</span></span>
                                    <b-popover :target="`average-mob`" :placement="`top`" triggers="focus">
                                        <p>Although we are looking at introducing electric vehicles with a future vision in mind, we are yet
                                            to establish clear plans. However, we have started looking at the best electric car and van
                                            options.</p>
                                    </b-popover>
                                </div>
                                <div class="slider-vertical-spacer"></div>
                            </div>
                            <div class="col content-block">
                                <div class="description-block">
                                    <span class="heading">We're pretty confident <span class="info" tabindex="-1" id="confident-mob">i</span></span>
                                    <b-popover :target="`confident-mob`" :placement="`top`" triggers="focus">
                                        <p>We have identified the full value opportunity of introducing electric vehicles into our fleet and
                                            have identified electric cars or vans suitable for our business, which we will try out
                                            shortly.</p>
                                    </b-popover>
                                </div>
                                <div class="slider-vertical-spacer"></div>
                            </div>
                            <div class="col content-block">
                                <div class="description-block">
                                    <span class="heading">We're EV experts <span class="info" tabindex="-1" id="expert-mob">i</span></span>
                                    <b-popover :target="`expert-mob`" :placement="`top`" triggers="focus">
                                        <p>With clear targets for transition, we are proactively driving the change towards
                                            electric. To find the most suitable electric cars or vans for our driver and business
                                            requirements, we are trying models.</p>
                                    </b-popover>
                                </div>
                                <div class="slider-vertical-spacer"></div>
                            </div>
                        </div>
                        <div class="row line-chart-vertical" ref="chartwrap">
                            <div class="col">
                                <LineChartVertical :height="crHeight" :key="refreshChart"></LineChartVertical>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <DoughnutChartWrap :value="overallPercentage" :caption="'Overall Progress'"></DoughnutChartWrap>
                </div>
                <div class="col">
                    <DoughnutChartWrap :value="vehiclePercentage" :caption="'Vehicle Readiness'"></DoughnutChartWrap>
                </div>
                <div class="col">
                    <DoughnutChartWrap :value="driverPercentage" :caption="'Driver Readiness'"></DoughnutChartWrap>
                </div>
                <div class="col">
                    <DoughnutChartWrap :value="infrastructurePercentage"
                                       :caption="'Infrastructure Readiness'"></DoughnutChartWrap>
                </div>
                <div class="col">
                    <DoughnutChartWrap :value="costPercentage" :caption="'Cost Readiness'"></DoughnutChartWrap>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <Benefits></Benefits>
                </div>
            </div>
            <div class="row">
                <div class="col" v-if="! isAdmin">
                    <NavButtons :back="goBack"></NavButtons>
                </div>
            </div>
            <div class="row" v-if="isAdmin">
                <div class="col">
                    <AnswerList></AnswerList>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BPopover from 'bootstrap-vue/es/components/popover/popover'
    import NavButtons from './partials/NavButtons'
    import LineChart from './partials/LineChart'
    import LineChartVertical from './partials/LineChartVertical'
    import DoughnutChartWrap from './partials/DoughnutChartWrap'
    import Benefits from './partials/Benefits'
    import AnswerList from './partials/AnswerList'
    import AnswerPreload from './../../services/AnswerPreload';
    //TODO: possibly refactor ans split in to smaller components
    export default {
        name: "Result",
        components: {
            DoughnutChartWrap,
            NavButtons,
            LineChart,
            LineChartVertical,
            Benefits,
            AnswerList,
            BPopover
        },
        data() {
            return {
                goBack: false,
                crHeight: null,
                refreshChart: 0,
                resCopy1:"Well done. In terms of readiness, your business is making great strides and is well on the way to reaping the benefits of an electric fleet. You have an excellent understanding of charging infrastructure and other variables and are proactively driving the change towards an electric future.",
                resCopy2:"Great start, but in terms of readiness, your business is not quite ready for an electric fleet yet. Although the foundations have been laid, based on your responses, some areas still need addressing before the next level of readiness can be reached.",
                resCopy3:"Good start, but in terms of readiness, your business still has a way to go before it can drive the change towards an electric fleet. Now it’s time to assess and prioritise the areas of development that we’ve identified.",
            }
        },
        computed: {
            overallPercentage() {
                return this.$store.getters.getOverallReadiness * 100 / this.$store.getters.getMaxWeights.total
            },
            vehiclePercentage() {
                return this.$store.getters.getVehicleReadiness * 100 / this.$store.getters.getMaxWeights.vehicle
            },
            driverPercentage() {
                return this.$store.getters.getDriverReadiness * 100 / this.$store.getters.getMaxWeights.driver
            },
            infrastructurePercentage() {
                return this.$store.getters.getInfReadiness * 100 / this.$store.getters.getMaxWeights.inf
            },
            costPercentage() {
                return this.$store.getters.getCostReadiness * 100 / this.$store.getters.getMaxWeights.cost
            },
            isAdmin() {
                return this.$store.state.admin;
            },
            isPreLoad() {
                return this.$store.state.preload;
            },
            answerString() {
                return this.$store.getters.getAnswerString
            },
            resultCopy() {
                let copy = this.resCopy1;
                switch (true) {
                    case (this.overallPercentage > 75):
                        copy = this.resCopy1;
                        break;
                    case (this.overallPercentage < 75 && this.overallPercentage >50 ):
                        copy = this.resCopy2;
                        break;
                    case (this.overallPercentage < 50):
                        copy = this.resCopy3;
                        break;
                }

                return copy;
            }
        },
        methods: {
            resizeEvent() {
                this.crHeight = this.$refs.chartwrap.clientHeight;
                this.refreshChart++;
            },
            sendPageLoadEvent() {
                if (! this.isAdmin && !this.$store.state.preload) {
                    this.$gtag.logPageLoad('EV Maturity Tool - Results');
                }
            },
            sendDataEvent(label, data) {
                if (!this.isAdmin && !this.$store.state.preload) {
                    this.$gtag.logData(
                        'EV Maturity Tool',
                        label,
                        data
                    );
                }
            }
        },
        mounted() {
            this.crHeight = this.$refs.chartwrap.clientHeight;
            this.refreshChart++;
            if (!this.isAdmin) {
                AnswerPreload.setResultCookie(this.answerString);
            }
            this.sendPageLoadEvent();
            this.sendDataEvent("Self-assessed score", this.$store.state.selectedMaturity);
            this.sendDataEvent("Calculated score", this.overallPercentage);
        },
        created() {
            window.addEventListener("resize", this.resizeEvent);
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeEvent);
        },
    }
</script>

<style scoped lang="stylus">
    .flex-column-reverse
        .description-block
            padding 3rem 1rem !important

    .legend
        text-align center
        padding-bottom 1.5rem

        .guess
            margin-right 2rem

            &:before
                content ""
                border-radius 50%
                background-color $color-blue-petrol
                width 1.4rem
                height 1.4rem
                display inline-block
                margin-right 0.5rem

        .actual
            &:before
                content ""
                border-radius 50%
                background-color $color-turquoise
                width 1.4rem
                height 1.4rem
                display inline-block
                margin-right 0.5rem

    .line-graph-wrap
        position relative

        .slider-bg-grid
            height 100%
            margin 0 -1.5rem
            border-top: 0.2rem solid $color-grey-border
            border-bottom: 0.2rem solid $color-grey-border

            .content-block
                border-bottom: 0.2rem dashed $color-grey-border
                flex-basis content
                &:nth-child(1)
                    border: none

                .slider-vertical-spacer
                    width 30%
                    height 100%
                    float right

                .description-block
                    width 70%
                    height 100%
                    float left
                    padding 1rem

                    .heading
                        font-weight bold
                        color $color-blue-petrol

        .slider-bg
            width: 100%
            margin: 0
            text-align: center
            border-top: 0.2rem solid $color-grey-border
            border-bottom: 0.2rem solid $color-grey-border

            .col
                padding: 0
                border-right: 0.2rem dashed $color-grey-border

                &:nth-child(5)
                    border: none

            .description-block
                padding: 2rem 0.8rem

                .heading
                    font-weight: bold
                    color: $color-blue-petrol

                .slider-spacer
                    height: 22rem

        .line-chart
            width: 100%
            position absolute
            bottom 3rem
            left 0
            margin 0

            .col
                padding 0

        .line-chart-vertical
            width 30%
            position absolute
            bottom 0
            right 0
            height 100%

            .col
                padding 0

            canvas
                height 100% !important
</style>